/* eslint-disable react/prop-types */
import { /* AnswerObject, */ OpenEndedAnswerType } from '@sm/question-widgets/respondent-survey';
import React, { createContext, useState, useCallback, useContext, FC } from 'react';

import { GetCurrentSurveySessionQuery } from '~lib/generatedGqlTypes';
import { SurveyContext } from './SurveyContext';

// TODO: Add to `@sm/question-widgets/respondent-survey` types
type AnswerObject = {
  [key: string]: OpenEndedAnswerType;
};

type CurrentPageContextType = {
  questions?: NonNullable<
    NonNullable<GetCurrentSurveySessionQuery['surveyTakingSession']['currentPage']>['questionsQM']
  >['items'];
  answers?: AnswerObject | {};
  updateAnswers(answer: OpenEndedAnswerType): void;
};

export const CurrentPageContext = createContext<CurrentPageContextType>({
  questions: undefined,
  answers: undefined,
  updateAnswers: answer => {},
});

type CurrentPageProviderProps = {
  children: React.ReactNode;
};

export const CurrentPageProvider: FC<CurrentPageProviderProps> = ({ children }) => {
  // Local storage -> overrides data from survey.
  // Local storage should be cleared when we hit the next page button.

  const { activePage } = useContext(SurveyContext);
  const [questions] = useState(activePage?.questionsQM?.items);

  const initialAnswers = questions?.reduce(
    (acc, curr) => ({ ...acc, [curr.id]: { questionId: curr.id, value: '', touched: false, isDirty: false } }),
    {}
  );

  // Hydrate answers
  const [answers, setAnswers] = useState<AnswerObject | undefined>(initialAnswers);

  const updateAnswers = useCallback(
    answer => {
      setAnswers({
        ...answers,
        [answer.questionId]: answer,
      });
    },
    [answers]
  );

  return (
    <CurrentPageContext.Provider
      value={{
        questions,
        answers,
        updateAnswers,
      }}
    >
      <>{children}</>
    </CurrentPageContext.Provider>
  );
};

export default CurrentPageProvider;
